module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "id": ""
    }
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.showDevice),
      callback: function($$v) {
        _vm.showDevice = $$v
      },
      expression: "showDevice"
    }
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.tstChange
    },
    model: {
      value: (_vm.tst),
      callback: function($$v) {
        _vm.tst = $$v
      },
      expression: "tst"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.iNo),
      callback: function($$v) {
        _vm.iNo = $$v
      },
      expression: "iNo"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dLoading),
      expression: "dLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableDvData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.dvtotal
    },
    on: {
      "current-change": _vm.pageDvSelect,
      "size-change": _vm.pageDvSized
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "calc(100% - 24px)",
      "height": "100%",
      "background": "none",
      "padding-left": "24px",
      "padding-bottom": "24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.fileName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "dt-pushing"
  }, [_c('tr', {}, [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.version : ''))])]), _vm._v(" "), _c('td', {}, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.size : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_distributor')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.mechanismName : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_createTime')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.createTime : ''))])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "none",
      "min-height": "10px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "dt-word-title",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('app_skintro')) + "：\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dt-word-main",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "background": "none",
      "margin": "0 24px 24px 0"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.detail ? _vm.detail.memo : ''))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder gTopMg"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    on: {
      "click": _vm.allDel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulDel')) + " (" + _vm._s(_vm.sNum) + ")")]), _vm._v(" "), _c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.refreshList
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.shuaxin')))]), _vm._v(" "), _c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showDevice = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_appendpush')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 0
    }
  }, [_c('div', {
    staticClass: "gSpDiv"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_deviceName') + '/' + _vm.$t('app_deviceNo'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.tName),
      callback: function($$v) {
        _vm.tName = $$v
      },
      expression: "tName"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.statusVl),
      callback: function($$v) {
        _vm.statusVl = $$v
      },
      expression: "statusVl"
    }
  }, _vm._l((_vm.status), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.name,
        "value": item.vl
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cmData"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_deviceName'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticStyle: {
            "color": "#409EFF",
            "cursor": "pointer"
          }
        }, [_vm._v(_vm._s(scope.row.terminalName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_deviceNo'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticStyle: {
            "color": "#409EFF",
            "cursor": "pointer"
          }
        }, [_vm._v(_vm._s(scope.row.terminalNo))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "progress",
      "label": _vm.$t('app_process'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(scope.row.data ? scope.row.data.result.progress : scope.row.progress) + " %")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.taskStatus == 3 || scope.row.taskStatus == 5 || scope.row.taskStatus == -3),
            expression: "scope.row.taskStatus == 3 || scope.row.taskStatus == 5 || scope.row.taskStatus == -3  "
          }],
          staticStyle: {
            "color": "green",
            "cursor": "pointer"
          }
        }, [_vm._v(_vm._s(_vm.statusNames[scope.row.taskStatus]))]), _vm._v(" "), _c('label', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.taskStatus == 0),
            expression: "scope.row.taskStatus == 0 "
          }],
          staticStyle: {
            "color": "orange",
            "cursor": "pointer"
          }
        }, [_vm._v(_vm._s(_vm.statusNames[scope.row.taskStatus]))]), _vm._v(" "), _c('label', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.taskStatus == -1 || scope.row.taskStatus == -5 || scope.row.taskStatus == -10),
            expression: "scope.row.taskStatus == -1 || scope.row.taskStatus == -5 || scope.row.taskStatus == -10 "
          }],
          staticStyle: {
            "color": "red",
            "cursor": "pointer"
          }
        }, [_vm._v(_vm._s(_vm.statusNames[scope.row.taskStatus]))]), _vm._v(" "), _c('label', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.taskStatus != -1 && scope.row.taskStatus != 0 && scope.row.taskStatus != 3 && scope.row.taskStatus != -5 && scope.row.taskStatus != -10 && scope.row.taskStatus != 5 && scope.row.taskStatus != -3),
            expression: "scope.row.taskStatus != -1 && scope.row.taskStatus != 0 && scope.row.taskStatus != 3 && scope.row.taskStatus != -5  && scope.row.taskStatus != -10 && scope.row.taskStatus != 5 && scope.row.taskStatus != -3"
          }],
          staticStyle: {
            "color": "gray",
            "cursor": "pointer"
          }
        }, [_vm._v(_vm._s(_vm.statusNames[scope.row.taskStatus]))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_pushTime'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(scope.row.createTime))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "cancelNums",
      "label": _vm.$t('app_operate'),
      "width": "116"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_pause'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(1, scope.row.taskStatus)),
            expression: "showBtn(1, scope.row.taskStatus)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.downOperate(2, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pause"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_continue'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(2, scope.row.taskStatus)),
            expression: "showBtn(2, scope.row.taskStatus)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.downOperate(1, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-play"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_ccdown'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(3, scope.row.taskStatus)),
            expression: "showBtn(3, scope.row.taskStatus)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.downOperate(3, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-window-close"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_global.chongtui'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(4, scope.row.taskStatus)),
            expression: "showBtn(4, scope.row.taskStatus)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.repush(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-repeat"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(0, scope.row.taskStatus)),
            expression: "showBtn(0, scope.row.taskStatus)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.delRow(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ecebf33"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mission/detail.vue
// module id = 1035
// module chunks = 0